import { Card, CardProps } from '@euler/components/Card';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useMemo } from 'react';
import { StyleSheet } from 'react-native';

export const OrderInfoSection = memo(
  ({ style, headerStyle, titleTextStyle, ...props }: CardProps) => {
    const styles = useStyles();
    return (
      <Card
        headerStyle={[styles.header, headerStyle]}
        titleTextStyle={[styles.titleText, titleTextStyle]}
        style={[styles.card, style]}
        {...props}
      />
    );
  },
);

const useStyles = () => {
  const { rpx } = useResponsiveContext();
  return useMemo(
    () =>
      StyleSheet.create({
        card: {
          marginBottom: rpx(15),
        },
        header: {
          minHeight: rpx(44),
        },
        titleText: {
          fontFamily: FontFamily.NotoSans.Medium,
          fontSize: rpx(20),
          lineHeight: rpx(26),
        },
      }),
    [rpx],
  );
};
